import { Link, Typography } from '@mui/material';
import { AnnouncementBanner } from '@/shared/ui';

const dialogContent = (
  <>
    <Typography variant="body2" paragraph>
      We updated our Privacy Policy, DPA, and Terms of Service to clarify
      customer-configured advertising and measurement integrations. These
      updates clarify our terms, reflect changes to our services, and help
      ensure our legal documents remain accurate and transparent. These
      integrations are optional and enabled only by Customers.
    </Typography>
    <Typography variant="body2" paragraph>
      Our Terms of Service, Privacy Policy, and Data Processing Agreement will
      be updated effective October 19, 2026.
    </Typography>
    <Typography variant="body2" paragraph>
      Please review the updated documents:
      <br />
      &ndash;{' '}
      <Link
        href="https://www.campaignswell.com/terms"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms of Service
      </Link>
      <br />
      &ndash;{' '}
      <Link
        href="https://www.campaignswell.com/privacy"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </Link>
      <br />
      &ndash;{' '}
      <Link
        href="https://www.campaignswell.com/dpa"
        target="_blank"
        rel="noopener noreferrer"
      >
        Data Processing Agreement
      </Link>
    </Typography>
    <Typography variant="body2">
      If you have any questions about these updates, please do not hesitate to
      email us at{' '}
      <Link href="mailto:support@campaignswell.com">
        support@campaignswell.com
      </Link>{' '}
      or contact your CSM.
    </Typography>
  </>
);

export function LegalUpdateBanner() {
  return (
    <AnnouncementBanner
      storageKey="cw-legal-update-2026-10-dismissed"
      bannerText="We’re updating our legal documents."
      dialogTitle="We’re updating our legal documents"
      dialogContent={dialogContent}
      confirmLabel="I understand"
    />
  );
}
